export default "__VITE_ASSET__DQ1_sqqj__"